import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function RegionalLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/regional/login`, { email, password });
      localStorage.setItem("regionalToken", res.data.access_token);
      localStorage.setItem("regionalUser", JSON.stringify(res.data.user));
      navigate("/leader/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg-app, #f0f2f5)" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl mx-auto mb-4 flex items-center justify-center"
            style={{ background: "linear-gradient(135deg, #00AEEF, #0080b3)" }}>
            <Lock className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-2xl font-semibold text-[#1f2937]">Regional Leader Access</h1>
          <p className="text-sm text-[#6b7280] mt-1">Sagicor Technology Capability Assessment</p>
        </div>

        <form onSubmit={handleLogin}
          className="bg-white rounded-2xl p-8 shadow-lg border border-[#e5e7eb]">
          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-[#4b5563] mb-1.5 uppercase tracking-wider">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-[#d1d5db] text-sm focus:outline-none focus:ring-2 focus:ring-[#00AEEF]/30 focus:border-[#00AEEF]"
                placeholder="name@sagicor.com"
                required
                data-testid="regional-email-input"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#4b5563] mb-1.5 uppercase tracking-wider">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-[#d1d5db] text-sm focus:outline-none focus:ring-2 focus:ring-[#00AEEF]/30 focus:border-[#00AEEF]"
                placeholder="Enter your password"
                required
                data-testid="regional-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-6 py-3 rounded-lg text-white text-sm font-semibold flex items-center justify-center gap-2 transition-all"
            style={{ background: loading ? "#9ca3af" : "linear-gradient(135deg, #00AEEF, #0080b3)" }}
            data-testid="regional-login-btn"
          >
            {loading ? "Signing in..." : "Sign In"}
            {!loading && <ArrowRight className="w-4 h-4" />}
          </button>
        </form>
      </div>
    </div>
  );
}
